import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { AutocompletePlaces } from '@search-bar/entities/autocomplete-places';
import { LoaderRingType } from '@design-system/components/atoms/loader-ring/entities/loader-ring.types';
import {
  AutoCompleteDestination, AutoCompleteDestinationHotel, AutoCompleteDestinationLocation
} from '@shared/base-search-bar/entities/autocomplete-destionation';
import { AutocompletePlace } from '@shared/base-search-bar/entities/autocomplete';
import { PlaceType } from '@shared/base-search-bar/entities/place-type';
import { SearchType } from '@search-bar/entities/search-type';
import { EventProperties } from '@avo/interface/trigger-props';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { DropDownViewCloseAction } from '@ux/components/drop-down-view/entities/drop-down-view.types';

@Component({
  selector: 'app-packages-destination-autocomplete',
  templateUrl: './packages-destination-autocomplete.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PackagesDestinationAutocompleteComponent {

  @Input() viewAutocomplete = false;
  @Input() isDestinationSelected = false;
  @Input() isLoadingAutocompletePlaces = false;
  @Input() isMobile = true;
  @Input() cityAndAirportsAutocomplete = { airports: [], cities: [] } as AutocompletePlaces;
  @Input() hotelAndLocationsAutocomplete = { hotels: [], locations: [] } as AutoCompleteDestination;
  @Input() searchType: SearchType;
  @Input() placeType: PlaceType;
  @Input() query: string;

  @Output() closeAutocomplete: EventEmitter<void> = new EventEmitter<void>();
  @Output() setQuery: EventEmitter<string> = new EventEmitter<string>();
  
  @Output() popularAmplitudeEvent: EventEmitter<EventProperties> = new EventEmitter<EventProperties>();
  @Output() selectPopularPlace: EventEmitter<AutocompletePlace> = new EventEmitter<AutocompletePlace>();

  @Output() selectAirportOrCityEvent: EventEmitter<{
    place: AutocompletePlace, isAirport: boolean
  }> = new EventEmitter<{
    place: AutocompletePlace, isAirport: boolean
  }>();
  @Output() selectLocationEvent: EventEmitter<AutoCompleteDestinationLocation> =
    new EventEmitter<AutoCompleteDestinationLocation>();
  @Output() selectHotelEvent: EventEmitter<AutoCompleteDestinationHotel> = new EventEmitter<AutoCompleteDestinationHotel>();

  public readonly loaderRingType = LoaderRingType.Neutral;
  public readonly closeAction = DropDownViewCloseAction.Close;

  constructor() { }

  get inputPlaceListLabel(): string {
    return this.isDestinationSelected ? 'SEARCH_MODULE.LOCATION_SEARCH.TO' : 'SEARCH_MODULE.LOCATION_SEARCH.FROM';
  }

  get inputPlaceListPlaceholder(): string {
    return this.isDestinationSelected ? 'SEARCH_MODULE.DESTINATION_INPUT' : 'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION';
  }

  get inputPlaceListIcon(): Icon {
    return this.isDestinationSelected ? Icon.Location : Icon.StartPoint;
  }

}
